import VuejsDatepicker from 'vuejs-datepicker';
import i18n from '../../languages';

const dynLanguage = {
    get language() {
        return i18n.locale;
    },
    get months() {
        return i18n.t('datepicker.months');
    },
    get monthsAbbr() {
        return i18n.t('datepicker.months_short');
    },
    get days() {
        return i18n.t('datepicker.days');
    },
    get rtl() {
        return false;
    },
    get ymd() {
        return false;
    },
    get yearSuffix() {
        return i18n.t('datepicker.year_suffix');
    }
};

export default {
    name: 'datepicker',
    extends: VuejsDatepicker,
    created() {
        this.language = dynLanguage;
    },
};



// WEBPACK FOOTER //
// ./src/components/general/Datepicker.js